const country = {
  ad: '安道尔',
  ae: '阿拉伯联合酋长国',
  af: '阿富汗',
  ag: '安提瓜和巴布达',
  ai: '安圭拉',
  al: '阿尔巴尼亚',
  am: '亚美尼亚',
  ao: '安哥拉',
  ar: '阿根廷',
  as: '美洲萨摩亚',
  at: '奥地利',
  au: '澳大利亚',
  aw: '阿鲁巴',
  az: '阿塞拜疆',
  ba: '波斯尼亚 - 黑塞哥维那',
  bb: '巴巴多斯',
  bd: '孟加拉国',
  be: '比利时',
  bf: '布基纳法索',
  bg: '保加利亚',
  bh: '巴林',
  bi: '蒲隆地',
  bj: '贝宁',
  bm: '百慕达群岛',
  bn: '文莱达鲁萨兰国',
  bo: '玻利维亚',
  br: '巴西',
  bs: '巴哈马',
  bt: '不丹',
  bv: '布韦岛',
  bw: '博茨瓦纳',
  bz: '伯利兹',
  ca: '加拿大',
  cc: '科科斯（基林）群岛',
  cd: '扎伊尔共和国',
  cf: '中非共和国',
  cg: '刚果共和国',
  ch: '瑞士',
  ci: '科特迪瓦',
  ck: '库克群岛',
  cl: '智利',
  cm: '喀麦隆',
  cn: '中国',
  co: '哥伦比亚',
  cr: '哥斯达黎加',
  cv: '佛得角',
  cx: '聖誕島 (澳大利亚)',
  cy: '塞浦路斯',
  cz: '捷克共和国',
  de: '德国',
  dj: '吉布提',
  dk: '丹麦',
  dm: '多米尼克',
  do: '多米尼加共和国',
  dz: '阿尔及利亚',
  ec: '厄瓜多尔',
  ee: '埃塞俄比亚',
  eg: '埃及',
  eh: '西撒哈拉',
  er: '厄立特里亚',
  es: '西班牙',
  et: '埃塞俄比亚',
  fi: '芬兰',
  fj: '斐济',
  fk: '福克兰群岛 (马尔维纳斯)',
  fm: '密克罗尼西亚',
  fo: '法羅群島',
  fr: '法国',
  ga: '加蓬',
  gb: '英国',
  gd: '格林纳达',
  ge: '格鲁吉亚',
  gf: '法屬圭亞那',
  gh: '迦納',
  gi: '直布羅陀 (英国)',
  gl: '格陵兰',
  gm: '甘比亞',
  gn: '几内亚',
  gp: '瓜德罗普',
  gq: '赤道几内亚',
  gr: '希腊',
  gt: '瓜地馬拉',
  gu: '關島',
  gw: '几内亚比绍',
  gy: '圭亚那',
  hk: '香港',
  hm: '赫德岛和麦克唐纳群岛',
  hn: '洪都拉斯',
  hr: '克罗地亚',
  ht: '海地',
  hu: '匈牙利',
  id: '印度尼西亚',
  ie: '爱尔兰',
  il: '以色列',
  im: '馬恩島',
  in: '印度',
  is: '冰岛',
  it: '意大利',
  jm: '牙买加',
  jo: '约旦',
  jp: '日本',
  ke: '肯尼亚',
  kg: '吉尔吉斯斯坦',
  kh: '柬埔寨',
  ki: '基里巴斯',
  km: '科摩罗聯盟',
  kn: '圣基茨和尼维斯',
  kr: '韩国',
  kw: '科威特',
  ky: '开曼群岛',
  kz: '哈萨克斯坦',
  la: '老挝',
  lb: '黎巴嫩',
  lc: '圣卢西亚',
  li: '列支敦士登',
  lk: '斯里兰卡',
  lr: '利比里亚',
  ls: '莱索托',
  lt: '立陶宛',
  lu: '卢森堡',
  lv: '拉脱维亚',
  ma: '摩洛哥',
  mc: '摩纳哥',
  md: '摩尔多瓦',
  mg: '马达加斯加',
  mh: '马绍尔群岛',
  mk: '马其顿',
  ml: '马里',
  mm: '缅甸',
  mn: '蒙古',
  mo: '澳門',
  mp: '北马里亚纳群岛',
  mq: '马提尼克',
  mr: '毛里塔尼亚',
  ms: '蒙特塞拉特',
  mt: '马耳他',
  mu: '毛里求斯',
  mv: '马尔代夫',
  mw: '马拉维',
  mx: '墨西哥',
  my: '马来西亚',
  mz: '莫桑比克',
  na: '纳米比亚',
  nc: '新喀里多尼亚',
  ne: '尼日尔',
  nf: '诺福克岛',
  ng: '尼日利亚',
  ni: '尼加拉瓜',
  nl: '荷兰',
  no: '挪威',
  np: '尼泊尔',
  nr: '瑙鲁',
  nu: '紐埃',
  nz: '新西兰',
  om: '阿曼',
  pa: '巴拿马',
  pe: '秘鲁',
  pf: '法属波利尼西亚',
  pg: '巴布亚新几内亚',
  ph: '菲律宾',
  pk: '巴基斯坦',
  pl: '波兰',
  pm: '圣皮埃尔和密克隆群岛(法国)',
  pn: '皮特凯恩群岛',
  pr: '波多黎各',
  ps: '巴勒斯坦',
  pt: '葡萄牙',
  pw: '帕劳',
  py: '巴拉圭',
  qa: '卡塔尔',
  re: '留尼汪',
  ro: '罗马尼亚',
  rs: '塞尔维亚',
  rw: '卢旺达',
  sa: '沙特阿拉伯',
  sb: '所羅門群島',
  sc: '塞舌尔',
  sd: '苏丹',
  se: '瑞典',
  sg: '新加坡',
  sh: '聖赫勒拿',
  si: '斯洛文尼亚',
  sk: '斯洛伐克',
  sl: '塞拉利昂',
  sm: '圣马力诺',
  sn: '塞内加尔',
  so: '索马里',
  sr: '苏里南',
  st: '圣多美普林西比',
  sv: '萨尔瓦多',
  sz: '史瓦济兰',
  tc: '特克斯和凯科斯群岛',
  td: '乍得',
  tg: '多哥',
  th: '泰国',
  tj: '塔吉克斯坦',
  tk: '托克勞',
  tl: '东帝汶',
  tm: '土库曼',
  tn: '突尼斯',
  to: '汤加',
  tr: '土耳其',
  tt: '特立尼达和多巴哥',
  tv: '吐瓦鲁',
  tw: '台湾',
  tz: '坦桑尼亚',
  ua: '乌克兰',
  ug: '乌干达',
  us: '美国',
  uy: '乌拉圭',
  uz: '乌兹别克斯坦',
  va: '梵帝冈',
  vc: '圣文森特和格林纳丁斯',
  ve: '委内瑞拉',
  vg: '英屬處女群島',
  vi: '美屬維京群島',
  vn: '越南',
  vu: '瓦努阿图',
  wf: '瓦利斯和富图纳群岛',
  ws: '萨摩亚',
  xk: '科索沃',
  ye: '也门',
  za: '南非',
  zm: '赞比亚',
  zw: '津巴布韦',
};

const getCountry = (code) => {
  const lowerCode = code ? code.toLowerCase() : '';
  return country[lowerCode] || code;
};

export { getCountry };
